import { Mosaico } from 'views/dashboard/mosaico/mosaico';
import { Template } from 'views/dashboard/template';

const Routes = [
  {
    path: '/templates',
    view: Mosaico,
    layout: 'app',
    permission: 'user',
    title: 'Plantillas'
  },
  {
    path: '/templates/upload',
    view: Template,
    layout: 'app',
    permission: 'user',
    title: 'Plantillas'
  },
]

export default Routes;